import React from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import Phone from "@material-ui/icons/Phone";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: {
    ...importedStyle.cardTitle,
    paddingLeft: "20px",
    paddingTop: "30px",
    paddingBottom: "30px"
  },
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  labelHorizontal: {
    justifyContent: "center"
  },
  containerLine: {
    marginTop: "20px"
  },
  editButton: {
    textAlign: "right",
    margin: "10px"
  }
};

const NoPhoneAccount = props => {
  const { classes } = props;
  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <Phone />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          {" "}
          You don't have a phone Package
        </h4>
      </CardHeader>
      <CardBody>
        <h4 className={classes.cardTitle}>
          MCSnet offers high quality Residential and Business Phone Services.
          Call us to subscribe
        </h4>
      </CardBody>
    </Card>
  );
};

/*
export default withStyles(styles)(
  loadContent("user.session/broadbandtraffic", DataUsageCard)
);
*/

export default withStyles(styles)(NoPhoneAccount);
